import { connect } from 'react-redux'
import React, { Component, createRef } from 'react'
import { withRouter } from 'react-router-dom'

import { getProductCoverage, listBenefits } from '../../../apiCalls'
import { openCoverageAccordion } from '../../../actions/coverageActions'

import dataLayer from '../../../utils/dataLayer'


export class Accordion extends Component {
    constructor(props) {
        super(props);
        this.openCloseAccordion = this.openCloseAccordion.bind(this);
        this.divRef = createRef();
        this.lastElementPositionDelta = null;
    }

    componentWillUpdate() {
        if (!this.divRef.current) return
        this.lastElementPositionDelta = this.divRef.current.getBoundingClientRect().y;
    }

    componentDidUpdate(prevProps) {
        if (!this.divRef.current) return
        const currentElementPosition = this.divRef.current.getBoundingClientRect().y + window.scrollY;

        if (!prevProps.opened && this.props.opened)
            window.scrollTo(window.scrollX, currentElementPosition - this.lastElementPositionDelta)
    }

    openCloseAccordion() {
        this.props.openCoverageAccordion(this.props.code);
        if (!this.props.opened) {
            dataLayer.genericEvent('sg_event', 'sp_cobertura', 'click_abrir_accordion', 'mais_detalhes')
        }
    }

    render() {
        let containerClass = 'accordion ';
        containerClass += ((this.props.opened) ? 'active' : '');

        return (
            <li onClick={this.openCloseAccordion} ref={this.divRef}>
                <div className={containerClass}>
                    <span className="desc">{this.props.name}</span>
                    <span className="valor">{this.props.coverage}</span>
                </div>
                <div className={(this.props.opened) ? 'more-icon open' : 'more-icon'}>
                    <span />
                    <span />
                </div>
                <div className="acc-panel panel">
                    <hr className={this.props.position % 2 === 0 ? 'line-separator even-color' : 'line-separator odd-color'} />
                    <p>
                        {this.props.content}
                    </p>
                </div>
            </li>
        )
    }
}

export class AccordionContainer extends Component {
    render() {
        return (
            <div className="box-detalhes">
                <div className="header-box-detalhes">
                    <h3>{this.props.title}</h3>
                </div>
                <div className="body-box-detalhes">
                    <ul className="list-descricao">
                        {this.props.benefits.map(
                            (benefit, i) => {
                                let content = this.props.benefits_list.filter((b) => (b.code === benefit.code));
                                content = content.length >= 1 ? content[0].long_description : '';
                                return (
                                    <Accordion
                                        {...benefit}
                                        key={benefit.code}
                                        content={content}
                                        position={i}
                                        openCoverageAccordion={this.props.openCoverageAccordion} />
                                )
                            }
                        )}

                    </ul>
                </div>
            </div>
        )
    }
}

export class AccordionGroup extends Component {
    constructor(props) {
        super(props);

        getProductCoverage(this.props.match.params);
        listBenefits();
    }

    render() {
        const categories = this.props.productCoverage.benefits;
        const accordionContainers = [];

        if (categories)
            Object.keys(categories).forEach(
                category => accordionContainers.push(
                    <AccordionContainer
                        title={category}
                        key={category}
                        benefits={categories[category]}
                        benefits_list={this.props.benefits_list}
                        openCoverageAccordion={this.props.openCoverageAccordion} />
                )
            )

        return (
            <section className="detalhes-cobertura">

                <div className="component">
                    {accordionContainers}
                </div>
            </section>
        )
    }
}

export default withRouter(connect(
    state => ({
        plans: state.search.plans,
        productInfo: state.coverage.productInfo,
        productCoverage: state.coverage.productCoverage,
        benefits_list: state.purchase.benefits_list
    }),
    {
        openCoverageAccordion,
    }
)(AccordionGroup))



// WEBPACK FOOTER //
// ./src/components/coverage/accordion/Accordion.jsx